import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { User } from '../../../types/User';
import { changeUserGroup } from '../../../api/users';

interface BasicSelectProps {
    user: User
}

const BasicSelect: React.FC<BasicSelectProps> = ({ user }) => {
    const [userGroup, setUserGroup] = React.useState(user.user_group || 'customer');

    const handleChange = (event: SelectChangeEvent) => {
        setUserGroup(event.target.value as string);
        changeUserGroup(user.user_id.toString(), event.target.value as string)
            .then(() => {
                console.log(`User group changed to ${event.target.value} for user ID: ${user.user_id}`);
            })
            .catch((error) => {
                console.error(`Error changing user group for user ID: ${user.user_id}`, error);
            });

    };
    return (
        <FormControl fullWidth>
            <InputLabel size='small' id="demo-simple-select-label">User Group</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={userGroup}
                label="User Group"
                size='small'
                onChange={handleChange}
            >
                <MenuItem value={"admin"}>Admin</MenuItem>
                <MenuItem value={"customer"}>Customer</MenuItem>
                <MenuItem value={"premium"}>Premium</MenuItem>
            </Select>
        </FormControl>

    );
}
export default BasicSelect;